<section class="mainTopBanner toolsTopBanner section-pd pb-0">
    <div class="freeJournalCardTop">
        <div class="container" >
            <div class="row align-items-center justify-content-center">
                <div class="col-lg-9">
                    <div class="topBannerWrapper align-items-center">
                        <div class="top-banner-left text-center">
                            <h1 class="singleTag">期刊查找 </h1>
                            <p>免費期刊查找工具 — Trinka 的期刊搜尋助手，快速高效地幫你找到最適合投稿的期刊。透過先進 AI 技術，精準匹配你的研究主題，提高論文被接受的機率。</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-12">
                    <app-filter-journals></app-filter-journals>
                </div>
            </div> -->
        </div>
    </div>
    <app-journal-finder-tool></app-journal-finder-tool>
    <span class="shape shape-1"></span>
    <span class="shape shape-2"></span>
</section>

<app-journal-steps
    [sectionTitle]="sectionTitle"
    [stepDescription1]="stepDescription1"
    [stepDescription2]="stepDescription2"
    [stepDescription3]="stepDescription3"
></app-journal-steps>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="assets/images/yt-thumbnail/JournalFinderThumbnail.webp" width="600" height="338" alt="video thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「期刊查找」功能！ </p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常<a style="color: #0000ff;" (click)="scroll(target)" class="link text-link">見問答</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="trinka-title">
                    <h2>Trinka 期刊查找工具如何幫助你</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>Trinka 的期刊查找工具運用先進 AI 技術，根據你的論文摘要推薦最適合投稿的期刊。它會提供依據證據的建議，並展示各期刊的類似論文，讓你更有信心選擇合適的發表平台。此外，Trinka 還能辨識並標示掠奪性期刊，有效保護你免於不良出版商的侵害。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image bg-light-purple px-2 py-2 rounded">
                    <img src="assets/images/features/s1.svg" width="540" height="366" class="img-fluid" alt="journal-finder">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="list-wrapper-style-2 section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 期刊查找主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none pr-0">
                    <img src="assets/images/icons/AI-power.svg" width="40" height="40" alt="AI-Powered Journal Recommendations">
                    <h3>AI 智慧建議</h3>
                    <p>透過強大 AI 演算法，系統能精準解析您的研究摘要，匹配最適合的期刊。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards pr-0">
                    <img src="assets/images/icons/all-subjects.svg" width="40" height="40" alt="Works for all Subjects Areas">
                    <h3>支援所有領域研究</h3>
                    <p>涵蓋多元學科領域，結合龐大論文資料庫，助你精準找到理想期刊。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards pr-0">
                    <img src="assets/images/icons/large-database.svg" width="40" height="40" alt="Large Database of Scientific Publications">
                    <h3>完整期刊資料庫</h3>
                    <p>結合 OpenAlex 等來源的龐大科學出版物資料庫
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1 pr-0">
                    <img src="assets/images/icons/publication-trend.svg" width="40" height="40" alt="Publication Trends to Understand Citability">
                    <h3>掌握期刊發表趨勢</h3>
                    <p>顯示你研究領域的出版趨勢，幫助你評估研究的曝光度。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1 pr-0">
                    <img src="assets/images/icons/similar.svg" width="40" height="40" alt="Similar Articles for Perfect Scope Match">
                    <h3>搜尋相似論文</h3>
                    <p>瀏覽相似論文，確認投稿範圍無誤，降低被編輯退件的風險。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1 pr-0">
                    <img src="assets/images/icons/search-intutive.svg" width="40" height="40" alt="Smart Filters for Refined Search">
                    <h3>智慧篩選</h3>
                    <p>透過學科分類、開放取用、影響因子等多重篩選條件，精準縮小搜尋結果。
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<app-global-leaders></app-global-leaders>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>最佳免費期刊查找工具</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">選擇投稿期刊不再頭痛！Trinka 免費期刊查找工具，根據你的論文摘要，快速幫你找到最合適的期刊，投稿更輕鬆。
                    </p>
                    <p class="w-100">這些工具讓你省時又省力，確保研究成果能送到對的讀者手中。幾下點擊，就能了解出版社要求，快速找到最適合自己研究的期刊。
                    </p>
                    <div class="btn-group justify-content-center mt-4">
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class="filled-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>免費註冊</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">Trinka 期刊查找的適用對象</h3>
                    <p class="text-white w-100">不管你是研究生、經驗豐富的研究者，還是教授，來自各領域的學者都可以使用這款期刊查找工具，輕鬆簡化你的發表之路。</p>
                    <p class="text-white w-100">不管你是研究新手還是資深學者，Trinka 都能幫你找到新的發表方向。對想要順利發表研究成果的你來說，這是非常實用的好幫手。</p>
                    
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>如何為你的研究找到合適的期刊？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">選對期刊投稿，讓你的研究更容易被看見！從符合你研究領域和主題的期刊開始，看看它們的範圍、目標和讀者，確保投稿能順利被接受。</p>
                    <p class="w-100">接下來，別忘了留意期刊的知名度和是否被收錄，看看最新文章風格和品質怎麼樣。透過期刊查找工具，能讓你輕鬆又快速找到適合的期刊。
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 期刊查找工具背後有龐大的資料庫
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>收錄了數百萬篇不同領域的學術文章。無論你偏好哪種期刊資金模式或開放取用方式，都能依照自己的需求篩選，輕鬆找到最適合投稿的期刊。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Trinka 期刊查找工具致力維護推薦結果的可靠性
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>採用完善的演算法主動辨識並標示掠奪性期刊，幫助研究者避開不良出版商。專注於可信賴的期刊來源，提升用戶對搜尋結果的信心。這項功能對保障學術品質與公信力至關重要，讓你能安心投稿，無需擔心遭遇詐騙或不道德出版行為。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以選擇或篩選特定出版社或區域的期刊嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以！你可以透過篩選功能，鎖定特定出版社或區域的期刊。這項功能讓研究者根據個人喜好或策略目標，精準縮小選擇範圍。無論你想找區域性相關的期刊，或是重視出版社的聲譽，都能透過這些篩選條件，讓期刊選擇更符合你的研究需求。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        選擇投稿期刊時應考量哪些因素？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>選擇投稿期刊時，首先要考量您的研究主題與期刊的範疇是否相符，確保內容契合可大幅提升錄用機會。其次，思考期刊的讀者族群是否與您的研究對象一致，選擇能有效觸及目標讀者的出版管道。此外，也別忘了參考期刊的影響因子與學術聲譽，評估您的研究成果在該領域可能產生的影響力與能見度。</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用期刊查找工具時，有哪些最佳做法？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>首先，撰寫一份清楚且簡潔的摘要是關鍵。摘要中應突顯研究的核心發現與重要性，這有助於工具更精確地匹配適合的期刊。避免使用過多術語，以免影響搜尋結果的準確性。收到推薦結果後，請逐一檢視每本期刊的範疇與投稿要求，確認是否與您的研究主題、目標讀者與出版風格相符。同時保持開放的心態，有時意想不到的選項反而可能是更理想的投稿對象。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        我該如何找到可能會刊登我研究的期刊？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p class="mb-3">首先，找出與您研究領域相關的期刊是關鍵。您可以透過線上資料庫或像 Trinka Journal Finder 這類平台，探索適合的投稿選項。使用與您研究主題相關的關鍵字進行搜尋，有助於精準篩選出潛在符合的期刊，提升投稿成功的機會。</p>
                                        <p>當你取得期刊清單後，請仔細查看每本期刊的範圍與投稿指南，確認你的研究符合其主題焦點，能提升錄取機率。別忘了也要瀏覽近期發表的文章，評估期刊內容是否與你的研究相關。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Trinka 的期刊查找工具有什麼特點？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p class="mb-3">Trinka 的期刊查找工具能大幅簡化挑選合適期刊的流程。它根據您的摘要提供量身打造的推薦名單，幫助您節省時間與精力，專注於與研究內容高度契合的期刊，提高投稿效率與成功率。</p>

                                        <p>此外，使用期刊查找工具能提升論文被接受的機率。透過將你的研究與相關期刊精準配對，幫助你更有效地掌握複雜的出版環境。這項工具對於各階段的研究者來說都是寶貴的幫手。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        使用 Trinka 期刊查找工具的主要目的為何？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p class="mb-3">使用 Trinka 期刊查找工具的主要目的是簡化選擇合適投稿期刊的流程。該工具會分析你的論文摘要，並將其與相關期刊進行匹配，幫助你節省時間與心力。</p>

                                        <p>此外，它們也能確保你的研究觸及正確的目標讀者。選擇合適的期刊投稿，不僅能提高發表成功率，也有助於提升你在學術領域中的能見度。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionNineContent" aria-expanded="true"
                                        aria-controls="QuestionNineContent">
                                        如何使用期刊報告？
                                    </a>
                                </div>

                                <div id="QuestionNineContent" class="collapse" aria-labelledby="QuestionNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>若要有效使用期刊報告，請先輸入你的論文摘要。系統會根據內容進行分析，並推薦適合投稿的期刊。接著，請特別留意推薦結果中的重要指標，例如接受率與影響因子，這些資訊有助於你做出更明智的投稿決策。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        期刊報告包含哪些內容？
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>使用 Trinka 的期刊查找工具後，你將獲得一份專屬的期刊報告，提供與你的研究摘要高度匹配的期刊清單。每份報告都包含關鍵指標，如影響因子與接受率，協助你做出更明智的投稿決策。報告中也提供投稿流程與時間表等實用資訊，讓你的投稿之路更順暢。有了這些資源，你將能更有效率地掌握學術出版的節奏與方向。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/fuWNwHYFPFM"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>